import { handleActions } from 'redux-actions';

import {
  setAccountDetails,
  setAccountError,
  setCountries,
  setLoadingDataStatus,
  setAccountValidationParams,
} from '@app/actions/accountActions';

const initialState = {
  details: null,
  error: null,
  countries: [],
  isLoadingData: false,
  accountValidationParams: {},
};

export default handleActions({
  [setAccountDetails]: (state, { payload }) => ({
    ...state,
    details: payload,
    error: null,
  }),
  [setAccountError]: (state, { payload }) => ({
    ...state,
    details: null,
    error: payload,
  }),
  [setCountries]: (state, { payload }) => ({
    ...state,
    countries: payload,
  }),
  [setLoadingDataStatus]: (state, { payload }) => ({
    ...state,
    isLoadingData: payload,
  }),
  [setAccountValidationParams]: (state, { payload }) => ({
    ...state,
    accountValidationParams: payload,
  }),
}, initialState);
